import Head from "next/head";

import ErrorLayout from "page/error";
import { FAVICON, LOGO_GRADIENT_PNG } from "const/images";

const GrabError = ({ statusCode }: { statusCode: number }) => {
    const options: {
        statusCode: number;
        message?: string;
        description?: string;
    } = {
        statusCode
    };

    switch (statusCode) {
        case 401:
        case 403:
            options.message = `Thou shall not pass!`;
            options.description = `I'm sorry. I'm afraid I can't let you in.`;
            break;
        case 404:
            options.message = `Not found!`;
            options.description = `Sorry, I can't seem to find what you're looking for.`;
            break;
        case 500:
            options.message = `Whoops.`;
            options.description = `Sorry, I seem to be malfunctioning at the moment. Try again later?`;
            break;
    }

    return (
        <>
            <Head>
                {/* <!-- SEO --> */}
                <meta
                    name="description"
                    content="Real-time TV clip sharing across X (Twitter) and Facebook | Grabyo"
                />
                <link rel="icon" type="image/png" href={FAVICON} />
                <meta name="robots" content="noindex,nofollow" />
                {/* <!-- Meta Data --> */}
                <meta charSet="UTF-8" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1"
                />
                <meta httpEquiv="cache-control" content="max-age=0" />
                <meta httpEquiv="cache-control" content="no-cache" />
                {/* <!-- Generic Open Graph (og) Meta Data --> */}
                <meta property="og:title" content="Grabyo" />
                <meta property="og:url" content="https://grabyo.com" />
                <meta property="og:image" content={LOGO_GRADIENT_PNG} />
                <meta
                    property="og:description"
                    content="Watch it. Share it. Grab it."
                />
                {/* <!-- Facebook Specific Open Graph (og) Meta Data (https://developers.facebook.com/docs/opengraphprotocol/) --> */}
                <meta property="fb:admins" content="100002426364574" />
                <meta property="og:site_name" content="Grabyo" />
                {/* <!-- Twitter Card API (twitter) Meta Data (https://dev.twitter.com/docs/cards) --> */}
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:site" content="@Grabyo" />
                {/* <!-- Stylesheets --> */}
            </Head>
            <ErrorLayout {...options} />
        </>
    );
};

//TODO: not sure we can use getServerSideProps here (nextjs 12)
GrabError.getInitialProps = async ({ res, err }) => {
    const statusCode = res ? res.statusCode : err ? err.statusCode : null;
    return { statusCode };
};

export default GrabError;
